"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HostType = /** @class */ (function () {
    function HostType() {
    }
    HostType.IFrame = 0;
    HostType.Page = 1;
    return HostType;
}());
exports.default = HostType;
//# sourceMappingURL=HostType.js.map